document.addEventListener('DOMContentLoaded', function() {
  const elems = document.querySelectorAll('.logo-slider');
  
  elems.forEach(function(elem) {
    // Check screen width and set initialIndex accordingly
    const initialIndex = window.matchMedia('(max-width: 749px)').matches ? 0 : 1;
    
    const flkty = new Flickity(elem, {
      avoidReflow: true,
      prevNextButtons: true,
      draggable: true,
      wrapAround: true,
      contain: true,
      freeScroll: true,
      autoPlay: 4000, // Initial 5-second delay
      pageDots: false,
      initialIndex: initialIndex,
      arrowShape: "M45.107632 5.82952 L53.53207 14.795201 L24.285714 46.292352 L97.808833 46.292352 L97.808833 59.383744 L24.285714 59.383744 L53.53207 90.877568 L45.107615 99.952178 L1.377755 53.778731 L45.107632 5.82952 Z"
    });
    
    // After the initial delay, speed up the slider
    setTimeout(function() {
      // First stop the current autoplay
      clearInterval(flkty.player.tickInterval);
      
      // Then start new autoplay with faster speed
      flkty.options.autoPlay = 1200; // Change to your desired faster speed
      flkty.player.play();
    }, 3000); // Wait 5 seconds before changing speed
  });
});